import { State } from './state.class';
import { PrevisionData } from './previsionData.class';

export class LaneState {
  // tslint:disable-next-line:variable-name
  msg_type: string;
  lane: string;
  // tslint:disable-next-line:variable-name
  id_mov: number;
  presenceTimeStamp: string;
  QR: string;
  stateMach: {
    currentState: string;
    previousState: string;
    stateMachType: string;
  };
  state: State;
  previsionData: PrevisionData;
  printersSensors: {
    '1': {};
    '2': {};
  };
  OCRFrontResultPacket: {
    id_mov: string;
    plate: string;
    confidence: string;
    path_plate: string;
  };
  OCRPacket: any;
  authRequestedPacket: {
    card: string;
    timestamp: string;
    id_mov: string;
    laneType: string;
    from: string;
    to: string;
    lane: string;
    QR: string;
    plate: string;
    loadType: {};
  };
  authResponsePacket: {
    id_mov: string;
    lane: string;
    plate: string; // este es el del OCR
    authorized: string;
    tag: string;
    message: string;
    prevision: PrevisionData;
    authorization: {
      name: string;
      strResult: string;
    };
  };
  dispensers: {};
}
